import { z } from "zod";
import {
  InterestCalculationMethodEnum,
  TransferPaymentFineEnum,
} from "../enums";
import { MetaSchema } from "./shared";

export const LoanSchema = z.object({
  id: z.string(),
  interestRate: z.string(),
  interestCalculationMethod:
    InterestCalculationMethodEnum.interestCalculationMethodSchema,
  repaymentPeriod: z.number(),
  transferPaymentFineType:
    TransferPaymentFineEnum.transferPaymentFineTypeSchema,
  amountLimit: z.number().nullable(),
  percentageAmountLateFine: z.string(),
  fixedAmountLateFine: z.number().nullable(),
  percentageMarginCall: z.number(),
  percentageLiquidThreshold: z.number(),
  collateral: z.unknown().nullable(),
  minimumLtv: z.number(),
  maximumLtv: z.number(),
  currency: z.string(),
  network: z.string(),
  status: z.unknown().nullable(),
  minimumRank: z.string(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

const LoansSchema = z.object({
  data: z.tuple([z.array(LoanSchema), z.number()]),
  meta: MetaSchema.default,
});
export default LoansSchema;
export type LoanSchemaType = z.infer<typeof LoanSchema>;
export type LoansResponse = z.infer<typeof LoansSchema.shape.data>;
